import styled from 'styled-components';

export const StyledGraph = styled.div`
  height: 100%;
  width: 100%;
  margin-top: 1rem;
  & .highcharts-legend-item {
    & > .highcharts-point {
      stroke-width: 1;
      stroke: #ddd;
    }
  }
`;
